import { api } from "@api/api";
import { PlanMapOption } from "@modules/erpIntegrations/types";

import { PlanMapOptionPatchPayload } from "./types";

export async function editPlanMapOptionService(
  id: number,
  data: PlanMapOptionPatchPayload
): Promise<PlanMapOption> {
  const { data: option } = await api.patch<PlanMapOption>(
    `/v1/integration_plan_map_option_admin/${id}/`,
    data
  );

  return option;
}
